import { render, staticRenderFns } from "./formConfig.vue?vue&type=template&id=5974f5f8&scoped=true&"
import script from "./formConfig.vue?vue&type=script&lang=js&"
export * from "./formConfig.vue?vue&type=script&lang=js&"
import style0 from "./formConfig.vue?vue&type=style&index=0&id=5974f5f8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5974f5f8",
  null
  
)

export default component.exports